var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-wishlist d-flex",
      class: { "product-wishlist--active": _vm.isVariationInWishList },
      on: {
        click: function ($event) {
          return _vm.switchState()
        },
      },
    },
    [
      _c(
        "svg",
        {
          staticClass: "bi",
          attrs: { width: "18", height: "17", fill: "currentColor" },
        },
        [_c("use", { attrs: { "xlink:href": "#svg-wishlist" } })]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }